import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'TableBox',
  props: {
    appendClass: {
      type: String,
      default: null,
    },
    colspan: {
      type: Number,
      default: 1,
    },
  },
  setup(__props) {

  

return { __sfc: true, }
}

})